export default __webpack_public_path__ + "static/1-365b1f60bb2dec7fa116e3a69d1dc4c3.png";